import React from 'react';
import { FaLocationArrow } from 'react-icons/fa';
import { Link, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
const trainingDomains = [
	'Risques électriques et Habilitation',
	'Règles techniques et de sécurité liées aux installations électriques BT',
	'Consignation électrique BT & HTA NFC 18 510',
	'Qualité des travaux électriques',
	'Notion de base de la Maintenance',
	'Risques des Travaux en hauteur',
	'Technologie du réseau souterrain et équipements HTA',
	'Hygiène et sécurité sur les chantiers travaux',
	'Les règles qui sauvent',
	'Rôles de chargé de travaux, conducteur de travaux électriques, et chef de chantier',
	'Secourisme'
];
export const HoverMenu = () => {
	// Split domains into chunks of 5
	const chunkedDomains = [];
	for (let i = 0; i < trainingDomains.length; i += 6) {
		chunkedDomains.push(trainingDomains.slice(i, i + 6));
	}
	return (
		<div className='flex w-full h-full items-center justify-center'>
			<div className='relative group w-screen flex items-center justify-center  bg-[#87152B] h-2'>
				{/* Dropdown Trigger
				<div className='px-4 py-2 w-[200px] h-[40px] bg-[#87152B] text-white hover:bg-[#AC9961] hover:text-black focus:outline-none flex items-center justify-center'>
					Domaines de formation
				</div>
				<div className='absolute top-full left-0 w-full bg-[#AC9961] shadow-lg z-40 p-4 hidden group-hover:block'>
					<div className='grid grid-cols-3 gap-1'>
						{chunkedDomains.map((chunk, columnIndex) => (
							<div key={columnIndex} className='space-y-1'>
								{chunk.map((domain, index) => (
									<div
										key={index}
										className='flex items-center space-x-4 hover:shadow transition-all duration-300 ease-in-out rounded-lg h-12 hover:bg-[rgba(0,0,0,0.2)]'
									>
										<FaLocationArrow
											size={10}
											className='ml-2 text-[#87152B] my-1'
										/>
										<Link
											to={`/formation/module${index + 1}`}
											className='text-black font-semibold text-base  hover:text-white cursor-pointer '
										>
											{domain}
										</Link>
									</div>
								))}
							</div>
						))}
					</div>
				</div> */}
			</div>
		</div>
	);
};
